import type { Game } from '../shared/types';
export { gameCover, gameHero } from '../shared/game-art';

export function gameTitle(game: Pick<Game, 'slug' | 'name'>) {
  return game.name.split(/\s*[·•]\s*/)[0].trim();
}
